function resolutionToSeconds(resolution) {
    if (resolution === "D") return 86400;
    if (resolution === "W") return 7 * 86400;
    if (resolution === "M") return 30 * 86400;
    return parseInt(resolution, 10) * 60;
}

function bucketStartMs(tsMs, resolution) {
    const stepMs = resolutionToSeconds(resolution) * 1000;
    return Math.floor(tsMs / stepMs) * stepMs;
}

export function applyTradeToBar(prevBar, trade, resolution) {
    const vol = trade.volume ?? 0;
    const barTime = bucketStartMs(trade.ts, resolution);

    if (!prevBar || barTime > prevBar.time) {
        return {
            time: barTime,
            open: trade.price,
            high: trade.price,
            low: trade.price,
            close: trade.price,
            volume: vol,
        };
    }

    if (barTime === prevBar.time) {
        return {
            ...prevBar,
            high: Math.max(prevBar.high, trade.price),
            low: Math.min(prevBar.low, trade.price),
            close: trade.price,
            volume: (prevBar.volume ?? 0) + vol,
        };
    }

    return prevBar;
}
